import React from "react";
import { DashboardComponent } from "@aidkitorg/types/lib/survey";
import { DashboardComponentResult } from "@aidkitorg/types/lib/admin-panel/dashboard";

type MetricProps = {
  component: DashboardComponent,
  result?: DashboardComponentResult
}

export const Metric = ({ component, result }: MetricProps) => {

  // This shouldn't happen but in case we render this for a component that isn't a Hero Number kind
  // This is more of a type-assurance for TypeScript
  if (component.kind !== 'Hero Number') {
    // Throw an error here
    return (<></>)
  }

  const metricValue = () => {
    if (!result?.data?.length) return '--';
    return result.data[0][result.summaryKey] ?? '--';
  }
  
  const prefix = component.prefix || ''
  const suffix = component.suffix || ''
  const value = metricValue()

  // Determine decimal places: 2 for percentages, use component setting for others, default to 0
  const decimalPlaces = component.summary.kind === 'Percentage' ? 2 : (component.decimalPlaces ?? 0);
  
  const formattedValue = !isNaN(value) ? 
    component.useCommas
      ? new Intl.NumberFormat('en-US', {
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: decimalPlaces,
      }).format(parseFloat(value))
      : parseFloat(value).toFixed(decimalPlaces) 
    : '--'

  return (
    // TODO: update styling so that it matches bolt better, leave for now
    <div className="text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold text-center">
      {prefix}{formattedValue}{suffix}
    </div>
  )
}